import { current } from '@reduxjs/toolkit';
export function updatePickingTaskItemsByMessage(draft, message) {
    const { pickingItem, task } = message;
    const itemIndex = draft.items.findIndex((item) => item.id === pickingItem.id);
    if (itemIndex === -1) {
        // TODO: add log to backend
        console.error(`In 'updatePickingTaskItemsByMessage', message contains pickingItem with id: '${message.pickingItem.id}', than is not found in list.`);
        console.log('Draft:', current(draft));
        console.log('message ', message);
        return;
    }
    draft.items[itemIndex].quantity = pickingItem.quantity;
    draft.items[itemIndex].pickedQuantity = pickingItem.pickedQuantity;
    draft.items[itemIndex].blockedQuantity = pickingItem.blockedQuantity;
    draft.task.quantity = task.quantity;
    draft.task.pickedQuantity = task.pickedQuantity;
    draft.task.blockedQuantity = task.blockedQuantity;
}
